import { FunctionComponent, h } from 'preact'
import { useState } from 'preact/hooks'

import { htmlEncodeByRegExp } from 'scripts/utils'
import { Button } from 'components/ui'
import FieldWrapper from '../components/FieldWrapper'
import { WelcomeField as WelcomeFieldType } from 'scripts/type'

import { FieldCommonProps } from '../type'
import classes from './index.scss'

const WelcomeField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, onFieldSubmit } = props
  const { label, description, buttonText } = field as WelcomeFieldType
  const labelText = htmlEncodeByRegExp(label || '')
  const descriptionText = htmlEncodeByRegExp(description || '')
  const [disabled, setDisabled] = useState(false)

  const handleClick = () => {
    setDisabled(true)
    onFieldSubmit?.('')
  }

  return (
    <FieldWrapper {...props} className={classes.wrapper}>
      <div className={classes.content}>
        <div className={classes.welcomeTitle} dangerouslySetInnerHTML={{ __html: labelText }} />
        {descriptionText && (
          <div className={classes.welcomeDesc} dangerouslySetInnerHTML={{ __html: descriptionText }} />
        )}
      </div>
      <div className={classes.welcomeButton}>
        <Button disabled={disabled} onClick={handleClick}>
          {buttonText}
        </Button>
      </div>
    </FieldWrapper>
  )
}

export default WelcomeField
